import * as device from 'react-device-detect';

export default device;
